import { TEventData } from "./@types/data/event"

const GA_LOADER_ID = "tracking-ga4-loader"
const GA_INLINE_ID = "tracking-ga4-inline"
const META_PIXEL_ID = "tracking-meta-pixel"

const removeIfPresent = (id: string) => {
  document.getElementById(id)?.remove()
}

const injectGoogleAnalytics = (measurementId: string) => {
  const existing = document.getElementById(GA_LOADER_ID) as HTMLScriptElement | null
  if (existing?.dataset.trackingId === measurementId) return

  removeIfPresent(GA_LOADER_ID)
  removeIfPresent(GA_INLINE_ID)

  const loader = document.createElement("script")
  loader.id = GA_LOADER_ID
  loader.async = true
  loader.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  loader.dataset.trackingId = measurementId
  document.head.appendChild(loader)

  const inline = document.createElement("script")
  inline.id = GA_INLINE_ID
  inline.dataset.trackingId = measurementId
  inline.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${measurementId}');
  `
  document.head.appendChild(inline)
}

const injectMetaPixel = (pixelId: string) => {
  const existing = document.getElementById(META_PIXEL_ID) as HTMLScriptElement | null
  if (existing?.dataset.trackingId === pixelId) return

  removeIfPresent(META_PIXEL_ID)

  const script = document.createElement("script")
  script.id = META_PIXEL_ID
  script.dataset.trackingId = pixelId
  script.innerHTML = `
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window, document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${pixelId}');
    fbq('track', 'PageView');
  `
  document.head.appendChild(script)
}

export const applyTracking = (event: TEventData | null) => {
  if (typeof document === "undefined") return

  if (event?.google_analytics_id) injectGoogleAnalytics(event.google_analytics_id)
  else {
    removeIfPresent(GA_LOADER_ID)
    removeIfPresent(GA_INLINE_ID)
  }

  if (event?.meta_pixel_id) injectMetaPixel(event.meta_pixel_id)
  else removeIfPresent(META_PIXEL_ID)
}
